import { Container } from './styled';
import { TiArrowForward } from 'react-icons/ti';

export function Forwarded(props) {
    const { children, isForwarded } = props;

    if (!isForwarded) {
        return children;
    }

    return (
        <Container>
            <span>
                <TiArrowForward/>
                {'Encaminhada'}
            </span>
            {children}
        </Container>
    );
}